import React from "react";
import SocailFireSummaryBlocker from "./socal-fire-summary-home-blocker";
import useActiveCustomer from "src/components/_shared/hooks/useCustomer/useActiveCustomer";
import { SSDDashboardView } from "src/components/portal/views/SSDDashboardView/components/ANDY-components/SSDDashboardView";
import { Customer } from "@natomas-org/core";

const SummaryPage = () => {
  const {info} = useActiveCustomer();
  const usedSocalFireRebuildsIntake = info?.used_socal_fire_rebuilds_intake;
  if (usedSocalFireRebuildsIntake) {
    return <SocailFireSummaryBlocker
      firstName={Customer.getFirstName(info)}
      email={Customer.getContactEmail(info)}
    />;
  } else {
    return <SSDDashboardView />;
  }
};

export default SummaryPage;
